import React from "react"
import { ReferenceBadgeProps } from "../types/badge"
import Icon from "../icon/icon.component"

export const ReferenceBadge = (props: ReferenceBadgeProps) => {
    return (
        <div className="badge badge-pill badge-custom-secondary">
            <Icon value={"file"}/>
            <a
                className={"text-white"}
                href={`/${props.reference.attributes.referenceKey}/${props.reference.attributes.referenceId}/edit`}>
                {props.reference.attributes.referenceIdentifier}
            </a>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/common/badge/ReferenceBadge.tsx